import React from "react";
import BusinessTabs from "./BusinessTabs";
import Section from "../../layouts/Section";
import FeatureDatabricksHead from "./FeatureDatabricksHead";

const FeatureLists = [
    {
        title: ["하나의 데이터로", "더 빠르게 연결하고"],
        description:
            "데이터가 여러 시스템에 분산되어 있어도 하나의 환경에서 통합적으로 관리하고 활용할 수 있습니다. 데이터 수집과 처리부터 분석까지 연결하여 데이터 활용에 필요한 복잡한 과정을 줄이고, 보다 빠르게 인사이트를 얻을 수 있습니다.",
        tags: ["#Data Integration", "#Data Engineering", "#Analytics"],
        imgSrc: "/img/databricks/feature-01.png"
    },
    {
        title: ["데이터에서 새로운", "인사이트를 발견하고"],
        description:
            "Databricks의 AI/BI와 AI 기능을 활용하면 복잡한 데이터를 자연어로 탐색하고 분석할 수 있습니다. 데이터의 의미와 맥락을 바탕으로 필요한 정보를 빠르게 찾고, 데이터 기반의 의사결정을 지원합니다.",
        tags: ["#AI-powered Analytics", "#Natural Language", "#AI/BI"],
        imgSrc: "/img/databricks/feature-02.png"
    },
    {
        title: ["데이터와 AI를", "안전하게 확장하고"],
        description:
            "데이터와 AI 활용이 확대될수록 체계적인 관리와 보안이 중요합니다. Unity Catalog를 기반으로 데이터 접근 권한과 계보, 감사 및 정책을 통합적으로 관리하여 안전하고 신뢰할 수 있는 데이터 환경을 구축할 수 있습니다.",
        tags: ["#Unity Catalog", "#Data Governance", "#Access Control"],
        imgSrc: "/img/databricks/feature-03.png"
    }
];

const FeatureDatabricks = () => {
    return (
        <>
            <BusinessTabs current="databricks" />

            <FeatureDatabricksHead />

            <Section id="1" bg="gray" space="lg">
                <h1 className="mx-auto max-w-4xl text-balance text-start text-h1 font-bold text-[#151515] sm:text-center">
                    데이터와 AI를 하나로 연결하는{" "}
                    <br className="hidden sm:block" />
                    지능형 플랫폼 <span className="text-[#ee3d2c]">Databricks</span>
                </h1>
                <p className="mx-auto mt-8 max-w-4xl text-start text-body leading-relaxed text-black sm:text-center">
                    다양한 데이터 소스를 하나로 연결하고, 데이터 엔지니어링부터
                    분석, BI, AI/ML까지 하나의 플랫폼에서 통합적으로 활용할 수
                    있습니다. Databricks의 Lakehouse 아키텍처를 기반으로 데이터의
                    가치를 극대화하고, AI를 통한 새로운 인사이트와 비즈니스
                    가치를 창출합니다.
                </p>
                <img
                    className="mx-auto mt-section h-auto w-full max-w-6xl object-contain"
                    src="/img/databricks/platform-diagram.png"
                    alt="Databricks Lakehouse 플랫폼 구성도"
                />
            </Section>

            <Section width="6xl" space="lg">
                <h1 className="mx-auto max-w-4xl text-balance text-start text-h1 font-bold text-[#151515] sm:text-center">
                    <span className="text-[#ee3d2c]">데이터와 AI,</span>{" "}
                    <br />
                    무엇이 달라지는가
                </h1>
                <p className="mx-auto mt-8 max-w-4xl text-start text-body leading-relaxed text-black sm:text-center">
                    Databricks는 단순한 데이터 플랫폼이 아닙니다.{" "}
                    <br className="hidden sm:block" />
                    데이터와 AI를 연결하여 비즈니스의 가능성을 확장하는 지능형
                    플랫폼입니다.
                </p>

                <div className="mt-section grid grid-cols-1 gap-section">
                    {FeatureLists.map((list, index) => (
                        <div
                            key={list.imgSrc}
                            className={`flex flex-col items-center justify-between gap-8 sm:gap-12 lg:gap-20 ${
                                index % 2 === 1
                                    ? "sm:flex-row-reverse"
                                    : "sm:flex-row"
                            }`}
                        >
                            <div className="w-full sm:w-[45%]">
                                <h2 className="text-balance text-h2 font-bold tracking-tight text-black">
                                    {list.title[0]}{" "}
                                    <br className="hidden sm:block" />
                                    {list.title[1]}
                                </h2>
                                <p className="mt-5 text-body leading-relaxed text-[#2b2b2b]">
                                    {list.description}
                                </p>
                                <ul className="mt-5 flex flex-wrap gap-3">
                                    {list.tags.map(tag => (
                                        <li
                                            key={tag}
                                            className="rounded-[7px] bg-[#f5f8fa] px-[9px] py-[9px] text-caption text-[#2b2b2b]"
                                        >
                                            {tag}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="w-full sm:w-[55%]">
                                <img
                                    className="h-auto w-full object-contain"
                                    src={list.imgSrc}
                                    alt=""
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </Section>
        </>
    );
};

export default FeatureDatabricks;
